<template>
    <ul class="list list-unstyled tw-m-0">
        <li v-if="users.length === 0" key="-1" class="tw-p-8 tw-text-center">
            {{ $t("feedback.analytics.userlist.noContent") }}
        </li>
        <li
            v-for="item in users"
            :key="item.user._id"
            class="tw-flex tw-flex-col tw-space-y-5 xl:tw-flex-row xl:tw-space-x-8 xl:tw-space-y-0 tw-items-center tw-py-5 tw-pr-8 tw-border-0 tw-border-b tw-border-solid tw-border-gray-100 tw-bg-white"
        >
            <a
                :href="`#/profile/${item.user._id}`"
                target="_blank"
                class="tw-truncate tw-text-gray-600 tw-w-72 tw-flex tw-items-center tw-space-x-4"
            >
                <l-profile-picture size="m" :user="item.user" />
                <div class="tw-font-medium tw-leading-6 tw-space-y-1">
                    {{ item.user.fullname }}
                    <span
                        v-if="item.user.stats && item.user.stats.feedbackStreak"
                        class="tw-block tw-text-gray-400 tw-font-normal tw-text-sm"
                    >
                        {{
                            $t(`feedback.analytics.userlist.isOnStreak`, [
                                item.user.stats.feedbackStreak || 0,
                            ])
                        }}
                    </span>
                </div>
            </a>

            <div
                class="tw-flex-1 tw-space-x-4 tw-text-right"
                :class="{ 'tw-opacity-60': sort.path !== 'badge' }"
            >
                <div
                    v-for="(amount, _id) in removeOutdatedBadges(item.badges)"
                    :key="_id"
                    v-b-popover.top.hover="badges[_id].name"
                    class="tw-border tw-border-solid tw-border-gray-200 tw-leading-6 tw-inline-block tw-text-center tw-select-none tw-bg-white tw-rounded-md tw-p-1 tw-relative tw-text-gray-600"
                    :class="{
                        'tw-transform hover:tw-scale-105 tw-border-gray-400':
                            sort.path === 'badge' && _id === sort.targetBadge,
                    }"
                >
                    <div
                        class="tw-leading-none tw-absolute tw-text-xxs tw-rounded-md tw--top-2 tw--right-2 tw-py-1 tw-px-2 tw-bg-gray-50"
                        :class="{
                            'tw-font-semibold tw-bg-gray-400 tw-text-gray-50':
                                sort.path === 'badge' && _id === sort.targetBadge,
                        }"
                    >
                        {{ amount }}
                    </div>
                    <img
                        v-if="badges[_id].icon"
                        class="tw-max-w-full tw-max-h-6"
                        :alt="badges[_id].name"
                        :src="badges[_id].icon"
                    />
                    <i v-else class="fal fa-trophy tw-leading-6" />
                </div>
            </div>

            <div
                v-for="type in ['sent', 'received', 'requested']"
                :key="type"
                class="tw-flex-grow-0 tw-w-20"
                :class="{ 'tw-opacity-60': sort.path !== type }"
            >
                <div class="tw-text-xl tw-font-semibold tw-text-gray-800 xl:tw-text-right">
                    {{ item[type] }}x
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import LProfilePicture from "@/components/LProfilePicture";

export default {
    components: {
        LProfilePicture,
    },
    props: {
        badges: {
            type: Object,
            default: () => ({}),
        },
        sort: {
            type: Object,
            default: () => ({}),
        },
        users: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        removeOutdatedBadges(badges = {}) {
            if (typeof badges !== "object") return {};

            const filteredBadges = {};
            for (const [key, value] of Object.entries(badges)) {
                if (this.badges[key]) filteredBadges[key] = value;
            }

            return filteredBadges;
        },
    },
};
</script>
